import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useState } from 'react';
import { useFormControl } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import RangePickersDay from './RangePickersDay.js';
import usePickerOpenState from '../usePickerOpenState.js';
import { AdapterLuxon } from '../../../node_modules/@mui/x-date-pickers/AdapterLuxon/AdapterLuxon.js';

var _excluded = ["size", "required", "error", "disabled", "slots", "slotProps", "rangeBoundary", "rangeStart", "rangeEnd", "rangeColor"];

var BaseDatePicker = function BaseDatePicker(_ref) {
  var _slotProps$desktopPap;

  var size = _ref.size,
      required = _ref.required,
      error = _ref.error,
      disabled = _ref.disabled,
      slots = _ref.slots,
      slotProps = _ref.slotProps,
      rangeBoundary = _ref.rangeBoundary,
      rangeStart = _ref.rangeStart,
      rangeEnd = _ref.rangeEnd,
      _ref$rangeColor = _ref.rangeColor,
      rangeColor = _ref$rangeColor === void 0 ? "primary" : _ref$rangeColor,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formControl = useFormControl();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      previewValue = _useState2[0],
      setPreviewValue = _useState2[1];

  var _usePickerOpenState = usePickerOpenState(),
      open = _usePickerOpenState.open,
      _onOpen = _usePickerOpenState.onOpen,
      onClose = _usePickerOpenState.onClose,
      popperProps = _usePickerOpenState.popperProps;

  var asRangePicker = rangeStart !== undefined || rangeEnd !== undefined;
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterLuxon
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({}, otherProps, {
    open: open,
    onOpen: function onOpen() {
      setPreviewValue(null);

      _onOpen();

      otherProps.onOpen && otherProps.onOpen();
    },
    onClose: onClose,
    disabled: disabled !== null && disabled !== void 0 ? disabled : formControl === null || formControl === void 0 ? void 0 : formControl.disabled,
    slots: _objectSpread2(_objectSpread2({}, slots), asRangePicker && {
      day: RangePickersDay
    }),
    slotProps: _objectSpread2(_objectSpread2({}, slotProps), {}, {
      popper: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.popper), popperProps),
      textField: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField), {}, {
        required: required !== null && required !== void 0 ? required : formControl === null || formControl === void 0 ? void 0 : formControl.required,
        error: error || formControl !== null && formControl !== void 0 && formControl.error ? true : undefined,
        // undefined allows internal validation errors to show
        size: size
      }),
      day: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.day), asRangePicker && {
        previewValue: previewValue,
        onPreviewChange: setPreviewValue,
        rangeBoundary: rangeBoundary,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        rangeColor: rangeColor
      }),
      desktopPaper: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.desktopPaper), asRangePicker && {
        sx: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : (_slotProps$desktopPap = slotProps.desktopPaper) === null || _slotProps$desktopPap === void 0 ? void 0 : _slotProps$desktopPap.sx), {}, {
          ".MuiDayCalendar-weekContainer": {
            margin: 0
          },
          ".MuiPickersDay-root": {
            my: "1px"
          }
        })
      })
    })
  })));
};

BaseDatePicker.propTypes = {
  required: propTypes.bool,
  error: propTypes.bool,
  rangeBoundary: propTypes.any,
  rangeStart: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])]),
  rangeEnd: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])])
};
var BaseDatePicker$1 = BaseDatePicker;

export { BaseDatePicker$1 as default };
